export default function About() {
  return (
    <div id="About" className="px-4 max-w-3xl mx-auto pt-24 sm:pt-32 mb-20">
      <h3 className="font-bold text-lg sm:text-xl mb-5 dark:text-white">
        About Me
      </h3>
      <p className="sm:text-lg dark:text-dark_text">
        Hi, I am Asifur, a passionate front-end developer from Bangladesh. I
        have been working and learning about front-end development for almost
        two years. I have strong fundamentals in Frontend technologies such as
        HTML, SCSS, JAVASCRIPT, REACT.JS, REDUX, etc.
        <br /> <br /> I am currently a final year Diploma student in the
        department of Computer Science.Also, I am interested in open source
        contributions on GitHub, I always search for the project which interests
        me the most so that I can contribute to that project. You can see my
        contributions on my{" "}
        <a href="https://github.com/asifurrahaman754" className="text-primary">
          GitHub
        </a>{" "}
        profile.
      </p>

      <div className="flex flex-wrap gap-2 uppercase mt-5 text-sm">
        <a href="https://github.com/asifurrahaman754">
          <img
            src="https://img.shields.io/badge/Github-000000?style=for-the-badge&amp;logo=github&amp;logoColor=white"
            alt="Github Badge"
          />
        </a>
        <a href="https://www.linkedin.com/in/asifurrahaman/">
          <img
            src="https://img.shields.io/badge/LinkedIn-0077B5?style=for-the-badge&amp;logo=linkedin&amp;logoColor=white"
            alt="Linkedin Badge"
          />
        </a>
        <a href="https://twitter.com/asifur754">
          <img
            src="https://img.shields.io/badge/Twitter-1DA1F2?style=for-the-badge&amp;logo=twitter&amp;logoColor=white"
            alt="Twitter Badge"
          />
        </a>
        <a href="mailto:asifurrahaman754@gmail.com">
          <img
            src="https://img.shields.io/badge/Gmail-D14836?style=for-the-badge&amp;logo=gmail&amp;logoColor=white"
            alt="Mail Badge"
          />
        </a>
        <a href="https://www.facebook.com/asif.asifurrahaman.77/">
          <img
            src="https://img.shields.io/badge/Facebook-1877F2?style=for-the-badge&amp;logo=facebook&amp;logoColor=white"
            alt="Facebook Badge"
          />
        </a>
      </div>
      <hr className="mt-5" style={{ color: "#f1f1f1" }} />
    </div>
  );
}
